import { db } from "../index";

const { vehicles } = require("./vehicle/vehicles");

export const tripTypeOptions = [
  { value: "distance", label: "Distance" },
  { value: "hourly", label: "A l'heure" },
];

// Re-export vehicles for compatibility
export { vehicles };

export const vehicleOptions = Object.keys(vehicles).map((key) => {
  return { value: key, label: vehicles[key].label };
});

export const detailedVehicleOptions = Object.keys(vehicles).map((key) => {
  return { value: key, label: vehicles[key]?.detailedLabel || vehicles[key].label };
});

export function getFilteredVehicleOptions(userInfos) {
  // If no restrictions defined, return all vehicles
  if (!userInfos?.child?.rights?.booking?.allowedVehicles) {
    return vehicleOptions;
  }

  const allowedVehicles = userInfos.child.rights.booking.allowedVehicles;
  
  // Filter vehicles according to restrictions
  // If a vehicle is not defined in restrictions, it is allowed by default
  return vehicleOptions.filter(vehicle => {
    const restriction = allowedVehicles[vehicle.value];
    return restriction !== false; // Only explicitly forbidden vehicles (false) are filtered
  });
}

export function getFilteredDetailedVehicleOptions(userInfos) {
  // If no restrictions defined, return all vehicles
  if (!userInfos?.child?.rights?.booking?.allowedVehicles) {
    return detailedVehicleOptions;
  }

  const allowedVehicles = userInfos.child.rights.booking.allowedVehicles;
  
  // Filter vehicles according to restrictions
  // If a vehicle is not defined in restrictions, it is allowed by default
  return detailedVehicleOptions.filter(vehicle => {
    const restriction = allowedVehicles[vehicle.value];
    return restriction !== false; // Only explicitly forbidden vehicles (false) are filtered
  });
}

export async function getTarifs(uid) {
  const snap = await db.ref(`users/${uid}/CityTariffs`).once("value");

  let res = [];
  snap.forEach((child) => {
    res.push({ ...child.val(), id: child.key });
  });

  return res;
}

export async function getTarifsOptions(uid) {
  const tarifs = await getTarifs(uid);
  return tarifs.map((tarif) => ({
    value: tarif.id,
    label: tarif.cityName,
    data: tarif,
  }));
}
